import { j as a } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const l = r((m, e) => /* @__PURE__ */ a.jsx(
  i,
  {
    ref: e,
    ...m,
    image: (o) => /* @__PURE__ */ a.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...o,
        children: /* @__PURE__ */ a.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M16 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8m0 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8m2 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0m2 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0M7.34 11a2 2 0 1 0-3.464-2 2 2 0 0 0 3.464 2m1.732 1a4 4 0 1 0-6.928-4 4 4 0 0 0 6.928 4m18.32 8.268a2 2 0 1 1-2 3.464 2 2 0 0 1 2-3.464m1-1.732a4 4 0 1 1-4 6.928 4 4 0 0 1 4-6.928M7.34 21a2 2 0 1 0-3.464 2 2 2 0 0 0 3.464-2m1.732-1a4 4 0 1 0-6.929 4 4 4 0 0 0 6.929-4m16.32-11.732a2 2 0 1 1 2 3.464 2 2 0 0 1-2-3.464m-1-1.732a4 4 0 1 1 4 6.928 4 4 0 0 1-4-6.928",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
l.displayName = "Acne7Icon";
export {
  l as Acne7Icon,
  l as default
};
//# sourceMappingURL=index.js.map
